import styles from "./WhiteAssetCardContainer.module.scss";
import { ReactNode } from "react";
import { clsx } from "clsx";

export default function WhiteAssetCardContainer({
  children,
  tagName: TagName,
  className,
  dynamicStyles,
}: {
  children: ReactNode;
  tagName: "li" | "div";
  className?: string;
  dynamicStyles?: React.CSSProperties;
}) {
  return (
    <TagName
      className={clsx(styles.container, className)}
      style={dynamicStyles}
    >
      {children}
    </TagName>
  );
}
